import { suAxios } from './axios';

export const addStatementToBot = async (question, answer) => {
  const response = await suAxios.post('/admin/psychic-bot', { input: question, response: answer });
  console.trace(response);
};



// WEBPACK FOOTER //
// ./src/utils/psychic_bot_apis.js